import * as React from "react";
import { observer } from "mobx-react";
import { lang } from "../../lang";
import { store } from "../../store";
import { store as uiStore } from "../../store/ui";
import { Title } from "../../components/atoms/Text";
import { Button } from "../../components/atoms/Button";
import { Table } from "../../components/molecules/Table";
import { Popup } from "../../components/molecules/Popup";
import { downloadFiles } from "../../data/downloadFiles";
import { downloadPreparation } from "../../actions/downloadPreparation";
import { DOWNLOAD_STATUS, pad } from "../../HelperSrc";
import { getDownloadStatus } from "../../actions/getDownloadStatus";
import { catchEndpoint } from "../../catchEndpoint";
import { api } from "../../api";
import * as HelperSrc from "../../HelperSrc";

@observer
class DownloadPopup extends React.Component<{
    big?: boolean;
    showClose?: boolean;
}> {
    public processTimer: NodeJS.Timeout | null = null;
    state = {
        isShow: true,
        downloadPopup: false
    };
    isDownloadReady = false;

    public componentDidMount(): void {
        this.processTimer = setInterval(() => {
            if (uiStore.getIsShowDownload()) {
                this.updateDownloading();
                HelperSrc.setLastActivity();
            }
        }, 4000);
    }

    public downloadZip(workbook: string | null) {
        const url = `${uiStore.apiPath}/client/${store.db || ""}/workbook/${workbook || ""}/download_zip/?download_time=${uiStore.downloadTime}`;
        window.open(url, "_blank");
        uiStore.setDownloadStatus(DOWNLOAD_STATUS.DOWNLOADED);
        store.setDownloadingFile([]);
        store.setWaitingDownload([]);
        HelperSrc.setLastActivity();
    }

    public prepareZip = () => {
        uiStore.setPreparingDownload(true);
        const dt = new Date();
        const downloadTime = `${dt.getFullYear()}${pad(String(dt.getMonth() + 1))}${pad(String(dt.getDate()))}-${pad(String(dt.getHours()))}-${pad(
            String(dt.getMinutes())
        )}-${pad(String(dt.getSeconds()))}`;
        uiStore.setDownloadTime(downloadTime);
        if (uiStore && uiStore.downloadingWB) downloadPreparation(uiStore.downloadingWB).catch(catchEndpoint);
        HelperSrc.setLastActivity();
    };

    public onClose = () => {
        this.isDownloadReady = false;
        uiStore.setIsShowDownload(false);
    };

    public updateDownloading = () => {
        if (uiStore.preparingDownload) {
            if (uiStore.downloadStatus === DOWNLOAD_STATUS.FINISH && uiStore.downloadingWB) {
                getDownloadStatus(uiStore.downloadingWB, DOWNLOAD_STATUS.FINISH).catch(catchEndpoint);
            } else if (uiStore.downloadStatus === DOWNLOAD_STATUS.DOWNLOADABLE) {
                if (api.workbookApi && store.db && store.db != "" && uiStore.downloadingWB) {
                    api.workbookApi.checkZipStatus(store.db, uiStore.downloadingWB, uiStore.downloadTime).then((response) => {
                        if (response instanceof Error || (response.message && response.message.error)) {
                            if (response instanceof Error) {
                                HelperSrc.writeLog("error", response);
                            } else {
                                store.doNotice(lang[response.message.error]);
                            }
                        } else {
                            const status = String(response.status);

                            if (status === "ready") {
                                this.isDownloadReady = true;
                                uiStore.setPreparingDownload(false);
                            }
                        }
                    });
                }
            }
        }
        if (uiStore.downloadingWB) {
            if (uiStore.downloadStatus == DOWNLOAD_STATUS.PROCESSING) {
                getDownloadStatus(uiStore.downloadingWB, DOWNLOAD_STATUS.FINISH).catch(catchEndpoint);
            }
        }
    };

    public render(): React.ReactElement {
        const files = store.waitingDownload?.map((file) => {
            const fileName = downloadFiles[file.filename] ? String(downloadFiles[file.filename]) : String(file.filename);
            let status = "";
            if (file.status == "PROCESSING") {
                status = lang.processing;
            } else if (file.status == "FINISH") {
                status = lang.done;
            }
            return {
                name: fileName,
                status
            };
        });

        return (
            <>
                {(uiStore.downloadStatus != DOWNLOAD_STATUS.DOWNLOADED || uiStore.preparingDownload) && uiStore.isShowDownload ? (
                    <Popup big showClose={true} onClose={this.onClose}>
                        <Title className="text_center">{lang.downloading}</Title>
                        <div className="padding-10">
                            <Table
                                data={files}
                                data-at_id="download_popup_tbl"
                                loading={files.length == 0}
                                columnNames={[
                                    { id: "name", name: lang.fileName },
                                    { id: "status", name: lang.status }
                                ]}
                            />

                            <Button
                                loading={
                                    uiStore.preparingDownload ||
                                    (uiStore.downloadStatus !== DOWNLOAD_STATUS.FINISH && uiStore.downloadStatus !== DOWNLOAD_STATUS.DOWNLOADABLE)
                                }
                                data-at_id={`download_button_${uiStore.downloadStatus}`}
                                title={lang.prepareZip}
                                displayNone={this.isDownloadReady}
                                onClick={this.prepareZip}
                                className={`popup-button ${this.isDownloadReady ? "display_none" : ""}`}
                            />

                            <Button
                                title={lang.download}
                                displayNone={!this.isDownloadReady}
                                data-at_id="download_button_final"
                                onClick={() => {
                                    uiStore.setIsShowDownload(false);

                                    store.doNotice(lang.downloadStart, true, 3000, () => {
                                        this.downloadZip(uiStore.downloadingWB);
                                        uiStore.setDownloadingWB(null);
                                        this.isDownloadReady = false;
                                    });
                                }}
                                className={`popup-button ${this.isDownloadReady ? "" : "display_none"}`}
                            />
                        </div>
                    </Popup>
                ) : null}
            </>
        );
    }
}

export { DownloadPopup };
